import React, {useContext} from "react"
import {RouteDetailContext} from "./context/RouteDetailContext";
import {CapabilityContext} from "../global/context/CapabilityContext";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Column from "@amzn/meridian/column";
import Divider from "@amzn/meridian/divider";
import CartContentV2 from "./CartContentV2";
import {NOT_IN_CART} from "../util/Constants";
import {FormattedMessage} from "react-intl";
import {getStationCode} from "../network/NetworkUtil";
import {getFCLMLink} from "../util/Util";
import {getPicklistTab} from "../util/EntityStatusManager";

const PicklistTabContent = () => {
    const {viewModelRD} = useContext(RouteDetailContext)
    const {configViewModel} = useContext(CapabilityContext)

    const filteredPicklists = viewModelRD.picklists.filter(picklist => {
        const picklistTab = getPicklistTab(picklist);
        return picklistTab === viewModelRD.selectedPicklistTab;
    });

    const stationCode = getStationCode()

    const renderPicklistInfo = (picklist) => {
        let containers = viewModelRD.picklistContainers[picklist.picklistId];
        containers = Array.isArray(containers) ? containers : [];

        const notInCart = containers.find(container => container.name === NOT_IN_CART);
        containers = containers.filter(container => container.name !== NOT_IN_CART);
        let notInCartPerPicklist = 0;
        if (notInCart) {
            containers.unshift(notInCart);
            notInCartPerPicklist = containers[0].packages.length;
        }
        const cartCount = containers.length - (notInCart ? 1 : 0);

        return (
            <Column key={picklist.picklistId} width="100%" marginBottom="medium">
                <Row width="100%" backgroundColor={"secondary"} spacingInset={"small"} spacing={"xlarge"}>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.status" defaultMessage="Status"/>:
                        </Text>
                        <Text type="b200">{picklist.status}</Text>
                    </Row>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.progress" defaultMessage="Progress"/>:
                        </Text>
                        <Text type="b200">{picklist.pickProgress}</Text>
                    </Row>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.associate" defaultMessage="Associate"/>:
                        </Text>
                        <Link key={picklist.picker} href={getFCLMLink(picklist.picker, configViewModel.stationConfig.fclmLinkEnabled, stationCode)} type="secondary"
                              target="_blank" rel="noreferrer noopener">
                            {picklist.picker}
                        </Link>
                    </Row>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.carts" defaultMessage="Carts"/>:
                        </Text>
                        <Text type="b200">{cartCount}</Text>
                    </Row>
                    <Row>
                        <Text type="h100">
                            <FormattedMessage id="routeInfo.notStowed" defaultMessage="Not Stowed"/>:
                        </Text>
                        <Text type="b200">{notInCartPerPicklist}</Text>
                    </Row>
                </Row>
                <Column width="100%">
                    {containers.map((container, index) => {
                        return <CartContentV2 key={container.name} index={index - (notInCart ? 1 : 0)} container={container} picklist={picklist}/>
                    })}
                </Column>
                <Divider/>
                <Row height="10px"/>
            </Column>
        )
    }
    return (
        <Column width="100%">
            {filteredPicklists.map(renderPicklistInfo)}
        </Column>
    )
}

export default PicklistTabContent


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/PicklistTabContent.js